// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { Toastr } from "@revvsales/components";

// Compotents Impprts
import { ChartHeader, PieChart } from "../Charts";
import DashboardLoader from "../DashboardLoader";

// Actions Imports
import DashboardActions from "../../../actions/DashboardActions";

// Internal Imports
import { DASHBOARD } from "../../../constants";
import { GlobalUtils } from "../../../utils";

// Destructuring
const { getDashboardDocDeals } = DashboardActions;
const { DOCUMENT_TYPES_HASMAP } = DASHBOARD;
const { handleApiErrMsg } = GlobalUtils;

class DocTypesChart extends Component {
  state = { showLoader: false };

  componentDidMount() {
    this._onInitData();
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _onInitData = () => {
    const { apiConfigs: { userID, fromDate, toDate } = {} } = this.props;
    this._toggleLoader(true);
    this.props
      .getDashboardDocDeals(userID, fromDate, toDate)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        console.error(`DocTypesChart(index.js) => _onInitData => ${error}`);
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _getView = () => {
    const {
      documentTyes,
      chartWidth,
      chartHeight,
      showDocDealsLoader,
    } = this.props;
    let data = [];
    let totalDocs = 0;

    if (documentTyes.length > 0) {
      data = documentTyes.map(docType => {
        totalDocs += docType.frequency;
        return {
          label: `${docType.frequency} ${DOCUMENT_TYPES_HASMAP[docType.name]}`,
          value: docType.frequency,
        };
      });
    }

    const chartConfigs = {
      data,
      chart: {
        defaultcenterlabel: `${totalDocs} <br>  Document Types`,
        plottooltext: `<b>$label</b> out of <b> ${totalDocs} </b> ($percentValue)  `,
      },
    };

    return (
      <Fragment>
        <ChartHeader
          title="Document Type Overview"
          dateTitle="Jan 01, 2019 July 01, 2019"
        />
        <PieChart
          width={chartWidth}
          height={chartHeight}
          configs={chartConfigs}
          showLoader={showDocDealsLoader}
        />
      </Fragment>
    );
  };

  render() {
    if (this.state.showLoader) {
      return <DashboardLoader message="loading document types" />;
    }
    return <Fragment>{this._getView()}</Fragment>;
  }
}

const mapStateToProps = state => {
  const { documentTyes } = state.DashboardStore;
  return {
    documentTyes,
  };
};

const mapDispatchToProps = {
  getDashboardDocDeals: (userID, fromDate, toDate) =>
    getDashboardDocDeals(userID, fromDate, toDate),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DocTypesChart);



// WEBPACK FOOTER //
// ./src/components/DashboardWrapper/DocTypesChart/index.js